/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'labor-auth': {
    width: 16,
    height: 16,
    viewBox: '0 0 24 24',
    data: '<defs/><g id="复杂大型图标"><path pid="0" class="cls-1" d="M3 19.44V21h9v-6.3c-3-.02-9 1.67-9 4.74zM8 9a4 4 0 0 0 4 3.59V9zM12 3.56a4 4 0 0 0-4 4 3.29 3.29 0 0 0 .05.44H12z"/><path pid="1" class="cls-2" d="M12 12.59A4 4 0 0 0 16 9h-4zM12 3.56V8h4a3.29 3.29 0 0 0 0-.44 4 4 0 0 0-4-4zM21 19.44c0-3.07-6-4.76-9-4.76V21h9z"/><g><path pid="2" class="cls-2" d="M16.5 7H12v1h4.5a.5.5 0 0 0 0-1z"/><path pid="3" class="cls-1" d="M7.5 7a.5.5 0 0 0 0 1H12V7z"/></g><g><path pid="4" class="cls-2" d="M12 3v4h.5V3.5A.5.5 0 0 0 12 3z"/><path pid="5" class="cls-1" d="M11.5 3.5V7h.5V3a.5.5 0 0 0-.5.5z"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/labor-auth.js